module.exports = __webpack_public_path__ + "static/media/logo-pague-facil.da8f659d.svg";